export default __webpack_public_path__ + "static/media/SN5-2.95276599.jpg";